import React from 'react';
import { Helmet } from 'react-helmet';
import { APP_TAGLINE, APP_NAME } from '../../Configs/appConfig';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import FeatureItem from './FeatureItem';
import { Link } from 'react-router-dom';
import { PRIVACY } from '../../Configs/routes';

class HomePage extends React.Component {
    render(){
        return (
        <>
            <Helmet>
                <title>{APP_NAME} - {APP_TAGLINE}</title>
                <link href="https://fonts.googleapis.com/css?family=Lato" rel="stylesheet"/>
                <link href="https://fonts.googleapis.com/css?family=Catamaran:100,200,300,400,500,600,700,800,900" rel="stylesheet"/>
                <link href="https://fonts.googleapis.com/css?family=Muli" rel="stylesheet"/>
            </Helmet>
            <header className="masthead">
            <Container className="h-100">
                <Row className="h-100">
                    <Col lg={7} className="my-auto">
                        <div className="header-content mx-auto">
                            <h1 className="mb-5">An Ultimate eSports Platform by NPPL</h1>
                            <p>Are you addicted to Online Games? Have you ever thought of earning through Online Gaming or from Playing
                            Mobile Games? What if you were rewarded for playing your favorite games and that too of which you are
                            addicted to? Well, NPPL is the Platform which makes this possible.</p>
                            <a href="http://orangelinks.in/nppl-esports" className="btn btn-outline btn-xl js-scroll-trigger link-unstyled">Download</a>
                        </div>
                    </Col>
                    <Col lg={5} className="my-auto">
                        <div className="device-container">
                            <div className="device-mockup iphone6_plus portrait white">
                                <div className="device">
                                    <div className="screen">
                                        <img src="img/ss1.webp" className="img-fluid" alt="App Screenshot"/>
                                    </div>
                                    <div className="button">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </header>

        <section className="section features" id="features">
            <Container>
                <div className="section-heading text-center">
                    <h2>Unlimited Features, Unlimited Fun</h2>
                    <p className="text-muted">Check out what you can do with this app</p>
                    <hr/>
                </div>
                <Row>
                    <Col lg={4} className="my-auto">
                        <div className="device-container">
                            <div className="device-mockup iphone6_plus portrait white">
                                <div className="device">
                                    <div className="screen">
                                        <img src="img/ss3.webp" className="img-fluid" alt=""/>
                                    </div>
                                    <div className="button">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={8} className="my-auto">
                        <Container fluid>
                            <Row>
                                <Col lg={6}>
                                    <FeatureItem
                                        icon="groups"
                                        title="Join Custom Tournaments"
                                        body="Enjoy the Custom Matches Everyday at Everytime. Play with your Own Friends,
                                        Perform Good & Get Rewarded."/>
                                </Col>
                                <Col lg={6}>
                                    <FeatureItem
                                        icon="emoji_events"
                                        title="Get Prizes on Each Kills & Chicken Dinner"
                                        body="Not only for Winning, but also on each Kills and to runner ups. Get Chicken
                                        Dinner or top positions to Smash the Win Prize!"/>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <FeatureItem
                                        icon="account_balance_wallet"
                                        title="Get Rewards Directly in popular Wallets"
                                        body="Redeem Your Winning directly into Paytm/Gpay or any UPI ID."/>
                                </Col>
                                <Col lg={6}>
                                    <FeatureItem
                                        icon="toll"
                                        title="Collect Battle Coins"
                                        body="Use Battle Coins to redeem items such as PUBG Mobile UC, Free Fire Diamond, PUBG
                                        Mobile Lite Batte Coins etc."/>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        </section>

        <section className=" section cta" id="download">
            <div className="cta-content">
            <div className="container">
                <h2>Stop waiting.<br/>Start playing.</h2>
                <a href="http://orangelinks.in/nppl-esports"
                    className="btn btn-outline btn-xl js-scroll-trigger link-unstyled">
                    Download Now!
                </a>
            </div>
            </div>
            <div className="overlay"></div>
        </section>

        <section className="section features" id="games">
            <Container>
                <div className="section-heading text-center">
                    <h2>Available Games</h2>
                    <hr/>
                </div>
                <Row>
                    <Col lg={4} className="my-auto">
                        <div className="device-container">
                            <div className="device-mockup iphone6_plus portrait white">
                                <div className="device">
                                    <div className="screen">
                                        <img src="img/ss2.webp" className="img-fluid" alt=""/>
                                    </div>
                                    <div className="button">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={8} className="my-auto">
                        <Container fluid>
                            <Row>
                            <Col lg={6}>
                                <div className="feature-item">
                                    <img src="img/pubgm.webp" alt=""/>
                                    <h3 align="text-center">PUBG Mobile</h3>
                                    <p className="text-muted">
                                        Enjoy the Custom Matches Everyday at Everytime. Play with your Own Friends, Perform Good & Get Rewarded.
                                    </p>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="feature-item">
                                    <img src="img/pubgmlite.webp" alt=""/>
                                    <h3>PUBG Mobile Lite</h3>
                                    <p className="text-muted">
                                        Not only for Winning, but also on each Kills and to runner ups. So you get rewarded even when you just score kills. Get Chicken Dinner or top positions to Smash the Win Prize!
                                    </p>
                                </div>
                            </Col>

                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <div className="feature-item">
                                        <img src="img/free%20fire.webp" alt=""/>
                                        <h3>Free Fire</h3>
                                        <p className="text-muted">Redeem Your Winning directly into Paytm/Gpay or any UPI ID.</p>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="feature-item">
                                        <img src="img/CODmobile.webp" alt=""/>
                                        <h3>COD Mobile</h3>
                                        <p className="text-muted">Use Battle Coins to redeem item from Store such as PUBG Mobile UC, Free Fire Diamond, PUBG Mobile Lite Batte Coins etc.</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <div className="feature-item">
                                        <img src="img/minimilitia.webp" alt=""/>
                                        <h3>Mini Militia</h3>
                                        <p className="text-muted">Redeem Your Winning directly into Paytm/Gpay or any UPI ID.</p>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="feature-item">
                                        <img src="img/ludo.webp" alt=""/>
                                        <h3>Ludo King</h3>
                                        <p className="text-muted">
                                            Use Battle Coins to redeem item from Store such as PUBG Mobile UC, Free Fire Diamond, PUBG Mobile Lite Batte Coins etc.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        </section>
        <footer>
            <Container>
            <p>&copy; {APP_NAME} 2020. All Rights Reserved.</p>
                <ul className="list-inline">
                    <li className="list-inline-item">
                        <Link to={PRIVACY} href="privacy/privacy.html">Privacy</Link>
                    </li>
                    <li className="list-inline-item">
                        <a href="mailto:nagalandppl20@gmail.com">Email-Us</a>
                    </li>
                </ul>
            </Container>
        </footer>
        </>
        );
    }
}

export default HomePage;